import { useContext } from 'react'

import { PdfContext } from './PdfContext'

export const usePdfContext = () => useContext(PdfContext)
